export default "/_next/static/images/magic-line-bottom-f281b15279438b7ad260ef35433d4721.png";